module.exports = __webpack_public_path__ + "img/microphone-stand.069fb83b.svg";